import React from 'react'

const OurPartnerComponent = () => {
  return (
    <section className="section1" style={{padding:"2rem 0"}}>
    <div className="container-xxl">
              <div className="row">
                  <div className="col-12">
                      <h1>Our Partners</h1>
                      <hr />
                      <h2 className="insurance-title">HEALTH INSURANCE PARTNERS</h2>
                          <ul className="insurance-partners">
                              <li>800Medigap</li>
                              <li>AAA Insurance Co.</li>
                              <li>AARP</li>
                              <li>Abrazo Health</li>
                              <li>ABS Healthcare</li>
                              <li>Acceptance</li>
                              <li>Admediary</li>
                              <li>Admiral Life</li>
                              <li>Advantra</li>
                              <li>Advocate Health</li>
                              <li>Aetna</li>
                              <li>AFLAC</li>
                              <li>AgedLeadStore.com</li>
                              <li>Agentra Healthcare</li>
                              <li>AHCP</li>
                              <li>AIG Direct Insurance Services, Inc.</li>
                              <li>AIU Insurance</li>
                              <li>Aliera Healthcare</li>
                              <li>All Digital Promotions</li>
                              <li>All Web Leads</li>
                              <li>Allegiant Group</li>
                              <li>Alliance Insurance</li>
                              <li>Allied Insurance</li>
                              <li>Allied Insurance Partners</li>
                              <li>Allstarz</li>
                              <li>Allstate Insurance</li>
                              <li>AllWebLeads</li>
                              <li>AmeriLife Group, LLC</li>
                              <li>Amerilife Marketing Group, LLC</li>
                              <li>Alpine Digital Group, Inc.</li>
                              <li>America’s Health Advisors</li>
                              <li>American Automobile Insurance</li>
                              <li>American Casualty</li>
                              <li>American Continental</li>
                              <li>American Deposit Insurance</li>
                              <li>American Empire Insurance</li>
                              <li>American Family Insurance</li>
                              <li>American Family Mutual</li>
                              <li>American Financial</li>
                              <li>American General</li>
                              <li>American Insurance Organization, LLC</li>
                              <li>American International Ins</li>
                              <li>American Life &amp; Health</li>
                              <li>American National Insurance</li>
                              <li>American Premier Insurance</li>
                              <li>American Republic</li>
                              <li>American Response Technologies Inc.</li>
                              <li>American Skyline Insurance Company</li>
                              <li>AmeriChoice</li>
                              <li>Amerigroup</li>
                              <li>AmeriHealth</li>
                              <li>Amica Insurance</li>
                              <li>Angelic Marketing Group</li>
                              <li>Anthem/BCBS</li>
                              <li>Apollo Interactive</li>
                              <li>Assurant</li>
                              <li>Assurant, Bankers Life and Casualty</li>
                              <li>Assured Life</li>
                              <li>Atlantic Indemnity</li>
                              <li>Atlantic Media</li>
                              <li>Atomic Leads</li>
                              <li>Audience Serv</li>
                              <li>Avenge Digital, LLC</li>
                              <li>AXA Advisors</li>
                              <li>Banker’s Fidelity</li>
                              <li>Bankrate</li>
                              <li>BBRS Group</li>
                              <li>Beacon Leads, LLC</li>
                              <li>Benefit Mall</li>
                              <li>Benepath</li>
                              <li>Best Agency USA</li>
                              <li>Best Obamacare</li>
                              <li>BestQuotes</li>
                              <li>Blip Marketing</li>
                              <li>Blue Cross Blue Shield</li>
                              <li>Blue Shield of California</li>
                              <li>Bold Media Group</li>
                              <li>Bravo Health</li>
                              <li>Brooke Insurance</li>
                              <li>Brookstone Financial</li>
                              <li>Btel</li>
                              <li>Btel Communications</li>
                              <li>Cal Farm Insurance</li>
                              <li>Call Center Partnerships</li>
                              <li>Cambia Health Solutions</li>
                              <li>Cege Media</li>
                              <li>Capital Choice</li>
                              <li>Centene</li>
                              <li>Cherry Blitz</li>
                              <li>Choice Direct</li>
                              <li>Chubb</li>
                              <li>Cigna</li>
                              <li>Citirex</li>
                              <li>Citizens</li>
                              <li>Clarendon American Insurance</li>
                              <li>Clarendon National Insurance</li>
                              <li>Clear One</li>
                              <li>ClearLink</li>
                              <li>Colonial Insurance</li>
                              <li>Community Care</li>
                              <li>Connect Insurance Brands</li>
                              <li>Connect Rite Bpo</li>
                              <li>ConnectiCare</li>
                              <li>Consumer United</li>
                              <li>Contactability</li>
                              <li>Continental Insurance</li>
                              <li>Corner Shop Media</li>
                              <li>Cotton States Insurance</li>
                              <li>Countershot Media Inc.</li>
                              <li>Country Insurance and Financial Services</li>
                              <li>Countrywide Insurance</li>
                              <li>Coventry</li>
                              <li>Coverage One Insurance Group LLC</li>
                              <li>Covida</li>
                              <li>CS Marketing</li>
                              <li>CSE Insurance Group</li>
                              <li>Datalot</li>
                              <li>Datwerx</li>
                              <li>Dairyland Insurance</li>
                              <li>DBR Insurance, LLC – David Brown</li>
                              <li>Direct Health Group</li>
                              <li>Discount Insurance Quotes</li>
                              <li>EasyHealth Insurance Services</li>
                              <li>e-TeleQuote Insurance, Inc.</li>
                              <li>eAmerifamily</li>
                              <li>eHealth</li>
                              <li>eHealthInsurance Services</li>
                              <li>Empire</li>
                              <li>Encompass</li>
                              <li>Energy Alliance</li>
                              <li>Ensurem, LLC</li>
                              <li>Ensurem II, LLC</li>
                              <li>Erie Insurance Company</li>
                              <li>Esurance</li>
                              <li>Exact Match Media Group</li>
                              <li>Excellus</li>
                              <li>Exclusive Media Partners</li>
                              <li>Family Life</li>
                              <li>Farmers Insurance</li>
                              <li>Farmers TX County Mutual</li>
                              <li>Farmers Union</li>
                              <li>Fidelis</li>
                              <li>Fidelity Life</li>
                              <li>Field of Leads Ltd.</li>
                              <li>Fields of Leads</li>
                              <li>Flyhigh</li>
                              <li>Freedom Health</li>
                              <li>Gaurantee Trust Life</li>
                              <li>Genworth</li>
                              <li>Genworth Financial</li>
                              <li>Get Me Healthcare</li>
                              <li>Gerber Life</li>
                              <li>GHI</li>
                              <li>GigUp</li>
                              <li>Globalsky BPO</li>
                              <li>GMAC Insurance</li>
                              <li>GMAC/NGIC</li>
                              <li>GoHealth</li>
                              <li>Golden Rule Insurance</li>
                              <li>GoMedigap</li>
                              <li>Gotham Surety</li>
                              <li>Government Employees Insurance</li>
                              <li>Government Personnel Mutual Life</li>
                              <li>Great American</li>
                              <li>Grey Peaks</li>
                              <li>Guaranty National Insurance</li>
                              <li>Guardian Healthcare</li>
                              <li>Guide One Insurance</li>
                              <li>Guide To Insure</li>
                              <li>Hanover</li>
                              <li>Hartford</li>
                              <li>Harvard Pilgrim</li>
                              <li>HasTraffic</li>
                              <li>Health America</li>
                              <li>Health Benefits Center</li>
                              <li>Health Benefits Direct</li>
                              <li>Health Benefits Exchange USA</li>
                              <li>Health Benefits One</li>
                              <li>Health Choice One</li>
                              <li>Health Connect Insurance Agency</li>
                              <li>Health Dime</li>
                              <li>Health Insurance Innovations</li>
                              <li>Health Insurance Services</li>
                              <li>Health Net</li>
                              <li>Health Plus of America</li>
                              <li>Healthcare Advisors</li>
                              <li>HealtheDeals</li>
                              <li>Healthedeals.com (“healthy deals”)</li>
                              <li>HealthIQ</li>
                              <li>HealthMarkets/Insphere</li>
                              <li>HealthMarkets Insurance Agency</li>
                              <li>HealthNet</li>
                              <li>HealthPartners</li>
                              <li>HealthPlanOne</li>
                              <li>HealthShare American</li>
                              <li>HealthSpring</li>
                              <li>Highland Health Group</li>
                              <li>Highmark</li>
                              <li>HIP Health Plan</li>
                              <li>HK Flavors Limited</li>
                              <li>Home Bundles</li>
                              <li>Home Path</li>
                              <li>Home Savings</li>
                              <li>Horizon Health Insurance</li>
                              <li>HPO</li>
                              <li>Humana</li>
                              <li>ICWleads</li>
                              <li>Ideal Concepts, Inc</li>
                              <li>IHC Group</li>
                              <li>IHC Specialty Benefits, Inc.</li>
                              <li>IGF Insurance</li>
                              <li>Independence American Insurance Company</li>
                              <li>Independence Blue Cross</li>
                              <li>Infinity National Insurance</li>
                              <li>Inside Response (Allied Insurance Partners)</li>
                              <li>Insphere</li>
                              <li>Insurance Care Direct</li>
                              <li>Insurance Insight</li>
                              <li>Insurance Services</li>
                              <li>Insurance.com</li>
                              <li>InsuranceLeads.com</li>
                              <li>Insurealife</li>
                              <li>IPA Direct</li>
                              <li>JMC Direct, LLC</li>
                              <li>Kaiser, Medicare Solutions</li>
                              <li>Kaiser Permanente</li>
                              <li>Kallstar</li>
                              <li>Landmark American Insurance</li>
                              <li>Lead Origins</li>
                              <li>Leader Preferred Insurance</li>
                              <li>Liberty National</li>
                              <li>Liberty Northwest Insurance</li>
                              <li>Lighthouse Insurance Group, LLC</li>
                              <li>Line East Leads</li>
                              <li>ListenClear</li>
                              <li>Live Calls Network</li>
                              <li>Longevity Alliance</li>
                              <li>Maryland Casualty</li>
                              <li>Mass Mutual</li>
                              <li>Medicare10</li>
                              <li>Medi Plans Now</li>
                              <li>Medicare Insure Supplement</li>
                              <li>Medicare Master</li>
                              <li>Medicare Solutions</li>
                              <li>Medicare Support Center</li>
                              <li>Multira</li>
                              <li>Medigap Select Insurance</li>
                              <li>MetLife</li>
                              <li>Metropolitan Insurance Co.</li>
                              <li>Mid Century Insurance</li>
                              <li>Middlesex Insurance</li>
                              <li>Midland National Life</li>
                              <li>Modern Health Benefits</li>
                              <li>Mutual of Omaha</li>
                              <li>My Best Health Plan</li>
                              <li>MyHealthAngel.com</li>
                              <li>National Health Connect LLC</li>
                              <li>National Health Hub LLC</li>
                              <li>National Health Insurance</li>
                              <li>National Healthcare Advisors</li>
                              <li>Nationwide Insurance Company</li>
                              <li>Navigate Medigap</li>
                              <li>New England Financial</li>
                              <li>New York Life Insurance</li>
                              <li>New Leaf Financial</li>
                              <li>Next Wave Marketing</li>
                              <li>Next Wave Marketing Strategies, Inc</li>
                              <li>NextGen Leads, LLC</li>
                              <li>Northwest Medical</li>
                              <li>Northwestern Mutual Life</li>
                              <li>Omni Insurance</li>
                              <li>Onviant, LLC</li>
                              <li>Onyx Digital Media</li>
                              <li>Open Market Quotes</li>
                              <li>Optimum HealthCare</li>
                              <li>Oxford</li>
                              <li>Pacific Life</li>
                              <li>Pafco General Insurance</li>
                              <li>Parasol Agents Network</li>
                              <li>Peak Performance</li>
                              <li>Portland Benefits</li>
                              <li>Power Source Marketing</li>
                              <li>Practical Health Insurance</li>
                              <li>Practical Marketing</li>
                              <li>Precise Leads</li>
                              <li>Precision Leads Media</li>
                              <li>Presidio Interactive</li>
                              <li>Preferred Mutual</li>
                              <li>Priority Health</li>
                              <li>Prudential Insurance Co.</li>
                              <li>Qatalyst</li>
                              <li>QuoteManage, LLC</li>
                              <li>QuickQuote</li>
                              <li>QuoteWhiz LLC</li>
                              <li>QuoteWizard</li>
                              <li>Rank Media Agency</li>
                              <li>Reel Media Ventures</li>
                              <li>Reliance Insurance</li>
                              <li>ReviMedia</li>
                              <li>RingRouter</li>
                              <li>Rogue E-Cigs</li>
                              <li>Safeway Insurance</li>
                              <li>Seascape</li>
                              <li>Seascape Health</li>
                              <li>Seascape Life</li>
                              <li>Secure Horizons</li>
                              <li>SelectQuote</li>
                              <li>SelectHealth</li>
                              <li>SelectQuote Insurance Services</li>
                              <li>Senior Health Direct</li>
                              <li>Senior Healthcare Direct</li>
                              <li>Senior Market Partners</li>
                              <li>Senior Market Quotes</li>
                              <li>Sentinel Insurance</li>
                              <li>Sentry Insurance Group a Mutual Company</li>
                              <li>Shelter Insurance Co.</li>
                              <li>Simple Health</li>
                              <li>Simple Health Plans Inc.</li>
                              <li>Simple Insurance</li>
                              <li>Smart Match Insurance Solutions</li>
                              <li>SolidQuote LLC</li>
                              <li>Simple Insurance Leads</li>
                              <li>Singularity Media</li>
                              <li>SolarJoy</li>
                              <li>Spring Health Plans</li>
                              <li>Spring Insurance Solutions</li>
                              <li>SS Telemarketing</li>
                              <li>Standard Life</li>
                              <li>Standard Security Life Insurance Company of New York</li>
                              <li>State Fund</li>
                              <li>Sterling</li>
                              <li>SubjectWell</li>
                              <li>Summit Health</li>
                              <li>Sun Coast</li>
                              <li>Superior Insurance</li>
                              <li>Superleads LLC</li>
                              <li>SYL Marketing Solutions</li>
                              <li>Synergy NMO</li>
                              <li>Tallac Media</li>
                              <li>The Hartford</li>
                              <li>The Lead Company</li>
                              <li>Tiburon Insurance Services</li>
                              <li>TICO Insurance</li>
                              <li>Titan</li>
                              <li>Tobias and Associates</li>
                              <li>Today Medicare</li>
                              <li>Torchlight Technology Group, LLC</li>
                              <li>TransAmerica</li>
                              <li>Travelers Insurance Company</li>
                              <li>TruBridge, Inc.</li>
                              <li>TrueChoice Insurance Services</li>
                              <li>TZ Insurance Solutions LLC</li>
                              <li>United Healthcare</li>
                              <li>United Medicare</li>
                              <li>United Medicare Advisors</li>
                              <li>United of Omaha</li>
                              <li>United Pacific Insurance</li>
                              <li>United Security</li>
                              <li>Unitrin Direct</li>
                              <li>Universal American</li>
                              <li>UQ Direct</li>
                              <li>US Web Leads</li>
                              <li>USA Benefits/Continental General</li>
                              <li>USAA</li>
                              <li>USF and G</li>
                              <li>Velapoint Insurance</li>
                              <li>Vertigen LLC</li>
                              <li>Visiqua</li>
                              <li>Voxify</li>
                              <li>Voxify LLC</li>
                              <li>Wax Digital Solutions Inc.</li>
                              <li>Wellcare</li>
                              <li>WellPoint</li>
                              <li>Western Mutual</li>
                              <li>Wheaten Worldwide</li>
                              <li>Windsor Insurance</li>
                              <li>Xpert Insurance Services</li>
                              <li>Yasha Marketing</li>
                              <li>5 Mile Media</li>
                              <li>ABS Healthcare</li>
                              <li>Ace Solutions</li>
                              <li>Admaric</li><li>Admediary</li><li>Adsparkx Digital</li><li>Advantage One Insurance</li><li>Advocator Group</li><li>Aetna</li><li>AgedLeadStore.com</li><li>AHCP</li><li>AIG</li><li>All Digital Promotions</li><li>All Web Leads</li><li>Allied Insurance</li><li>Allied Insurance Partners (view list)</li><li>Allstarz</li><li>Alphatech Resource Holdings s.r.o.</li><li>America’s Health Advisors</li><li>American Auto Club</li><li>American Continental</li><li>American Disability Helpline</li><li>American Family</li><li>American Health Reform Solutions</li><li>American Insurance Organization, LLC</li><li>American Republic</li><li>American Select Health</li><li>Andy Montague Region</li><li>Anthem/BCBS</li><li>Assurant, Bankers Life and Casualty</li><li>ATI Agency</li><li>Audience Serv</li><li>AutoGuard Pro</li><li>Automotive Services Center</li><li>Bad Ass Leads</li><li>Bankrate</li><li>BBRS Group</li><li>Beacon Leads, LLC</li><li>Benefit Advisors</li><li>BestQuotes</li><li>Blue Nile</li><li>BlueCross/Blue Sheild Association Companies</li><li>Bold Media Group</li><li>Boost</li><li>Boost Health Insurance</li><li>Boost Marketing Inc</li><li>Btel</li><li>Btel Communications</li><li>C3 Data, LLC</li><li>Call Center Partnerships</li><li>Cedar Tree Media</li><li>Cege Media</li><li>Cege Media</li><li>Choice Direct</li><li>Cigna, Coventry, Fortis</li><li>Citirex</li><li>Citizens Disability</li><li>Clean Energy Concepts</li><li>Clearlink</li><li>Compass Health Advisors</li><li>Connect Plus</li><li>Connect Rite Bpo</li><li>Contactability</li><li>Corner Shop Media</li><li>Crosspointe Insurance Advisors</li><li>D and D Investment Specialist</li><li>Datalot</li><li>Datwerx</li><li>Digital Market Media</li><li>Disability Advisor</li><li>DiscoverBPO</li><li>DKS Marketing</li><li>DPMP Media Inc.</li><li>e-TeleQuote Insurance, Inc.</li><li>Emerald Enterprise Corp</li><li>Energy Alliance</li><li>Excel Impact</li><li>Family First Health Plans</li><li>FCHCN Insurance Agency</li><li>Field of Leads Ltd.</li><li>Fields of Leads</li><li>Final Expense Assistant</li><li>Financial Grade</li><li>First Family</li><li>FirstAmericanFinancial</li><li>FiveStrata</li><li>Flyhigh</li><li>Genesis Solutions Group</li><li>Genworth Financial</li><li>Gerber Life</li><li>GHI</li><li>GigUp</li><li>Globalsky BPO</li><li>GoHealth</li><li>Golden Rule</li><li>Grey Peaks</li><li>Guardian Benefits</li><li>Guide to Insure</li><li>Guidestar Marketing Group LLC</li><li>HasTraffic</li><li>HauteProspects</li><li>Health Benefits Center</li><li>Health Benefits One</li><li>Health Dime</li><li>Health Insurance Advantage</li><li>Health Insurance Services</li><li>Health Net</li><li>Healthcare.com</li><li>HealthIQ</li><li>HealthMarkets/Insphere</li><li>HealthPlanOne</li><li>HealthSpire Calls</li><li>Heard and Smith</li><li>Highmark</li><li>HK Flavors Limited</li><li>Home Bundles</li><li>Home Path</li><li>Home Savings</li><li>HomeWarrantyProject.com</li><li>HP One</li><li>HPO</li><li>Humana</li><li>iCall Solutions</li><li>Ideal Concepts</li><li>Ideal Concepts, Inc</li><li>Innovate Financial Group</li><li>Inside Response</li><li>Insphere</li><li>Insuralife</li><li>Insurance Guide</li><li>Insurance Line One</li><li>Insurance Services</li><li>Insurance Solutions Direct LLC</li><li>Insurance Solutions LLC</li><li>Kaiser, Medicare Solutions</li><li>Kallstar</li><li>Kevin Ferrell Inc</li><li>Laser Marketing</li><li>Laser Marketing</li><li>Lead Origins</li><li>Lead Realm LLC</li><li>Legends United Insurance Agency</li><li>Lender Daily</li><li>Lendmarx</li><li>Lighthouse Insurance Group</li><li>Line East Leads</li><li>ListenClear</li><li>LizDev Inc.</li><li>LizDev, Inc</li><li>Medicare Concepts, LLC</li><li>Momentum Solar</li><li>Mutual of Omaha</li><li>MyHealthAngel.com</li><li>Narrate LLC</li><li>National Automotive Financial Services</li><li>National Disability</li><li>National Health Connect LLC</li><li>National Health Hub LLC</li><li>National Healthcare Advisors</li><li>National Income Life Insurance Company</li><li>National Repair Solutions</li><li>Nationwide Health Advisors</li><li>Next Wave Marketing</li><li>Next Wave Marketing Strategies, Inc</li><li>Northwest Medical</li><li>Number One Health Insurance Agency</li><li>Onyx Digital Media</li><li>OpenJar Concepts</li><li>Otis Production LLC</li><li>Ox Car Care</li><li>Palo Media Group</li><li>PCS</li><li>Peak Performance</li><li>Ping Leads</li><li>Pinnacle Publishers LLC</li><li>Policy Scout</li><li>PolicyBind</li><li>PolicyScout</li><li>Power Credit Solutions</li><li>Power Source Marketing</li><li>Power Source Marketing LLC</li><li>Practical Marketing</li><li>Precise Leads</li><li>Premier Disability</li><li>Premier Health Advisors, Inc.</li><li>Premier Health Associates</li><li>Presidio Interactive</li><li>Presidio Interactive Corp</li><li>Purple Dog Marketing LLC</li><li>Q3M Insurance Solutions</li><li>Qatalyst</li><li>Quantum 3 Media LLC</li><li>QuickQuote</li><li>Quote Velocity</li><li>Quotefire</li><li>QuoteStorm</li><li>Quotewizard</li><li>Rank Media</li><li>RateMarketPlace</li><li>Reliable Partners (Trips Marketing)</li><li>Resource Marketing Corp.</li><li>ReviMedia</li><li>Rogue E-Cigs</li><li>S.B. Fintech Ltd</li><li>Seascape</li><li>Seascape Health</li><li>Seascape Life</li><li>Secure Horizons</li><li>Select Quote</li><li>SelectQuote</li><li>SelectQuote</li><li>SeniorCare USA</li><li>Simple Health</li><li>Simple Health Plans Inc.</li><li>Simple Insurance Leads</li><li>Singularity Media</li><li>Smart Match Insurance Agency</li><li>Smart Match Insurance Solutions</li><li>SmartHome Solutions USA</li><li>SolidQuote</li><li>Spring EQ</li><li>Spring Venture Group</li><li>SS Telemarketing</li><li>Sterling</li><li>SubjectWell</li><li>Sun City Financial LLC</li><li>Support First</li><li>Synergy Marketing Associates</li><li>Tallac Media</li><li>The Medicare Assistant</li><li>The-Solar-Project</li><li>Thrive Marketing</li><li>Tiger Health Solutions</li><li>Torchlight Technology Group LLC</li><li>TradeMarc Global, LLC</li><li>Traffic Panda</li><li>Trips Marketing LLC</li><li>Trusted Consumer Advisors</li><li>TZ Insurance Solutions LLC</li><li>United Access insurance</li><li>United Healthcare</li><li>United Insurance Group Agency, Inc.</li><li>United Medicare</li><li>United Medicare Advisors</li><li>Universal American</li><li>US Dealer Services</li><li>US Health Advisors</li><li>US Health Advisors</li><li>US Insurance Advisors, LLC</li><li>US Marketing Group</li><li>USHEALTH Advisors</li><li>Vertigen LLC</li><li>Visiqua</li><li>Voxify</li><li>Voxify LLC</li><li>WeCall</li><li>WellPoint</li><li>West Coast Closers</li><li>Yasha Marketing</li>
                              <li>Spring Venture Group</li>
                              <li>YourMedicare.com, LLC</li>
                              <li>United Medicare Advisors</li>
                              <li>Smart Match Insurance Agency</li>
                              <li>WeQuote</li>
                          </ul>
                  </div>
              </div>
          </div>
  </section>
  )
}

export default OurPartnerComponent
